var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.loading == true)?_c('div',{staticClass:"no_class_box"},[_c('img',{attrs:{"src":require("../assets/img/wukemu.png"),"alt":""}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }